module.exports = __webpack_public_path__ + "static/img/company-logo3.be0e1b07.jpg";